<p-card class="xl-radius">
    <ng-template #header>
        <div class="row" [style]="{ 'padding': '1.5rem', 'border-bottom': '1px solid #e0e0e0' }">
            <div class="col-2">
                <img class="icon-smaller" src="icons/payment-method-icon.png" />
            </div>
            <div class="col-10">
                <h5 [style]="{ 'margin-block-start': 0, 'margin-block-end': 0 }">Betaalwijze</h5>
            </div>
        </div>
    </ng-template>
    <div class="row">
        <div class="col-12">
            <p class="text-center" [style]="{ 'padding': '8px', 'background-color': '#E8EFCD' }"><strong>&nbsp;{{ paymentDetails?.iban }}</strong></p>

            <p>Momenteel betaal je met {{paymentDetails?.paymentMethod == PaymentMethod.Overschrijving ? 'overschrijvingen' : paymentDetails?.paymentMethod == PaymentMethod.Domiciliering ? 'domicilliëring' : ''}}. Als je dat wil kan je dit hier aanpassen naar {{paymentDetails?.paymentMethod == PaymentMethod.Overschrijving ? 'domicilliëring' : paymentDetails?.paymentMethod == PaymentMethod.Domiciliering ? 'overschrijvingen' : ''}}.</p>
        </div>
    </div>
    <ng-template #footer>
        <div class="row" [style]="{ 'border-top': '1px solid #e0e0e0' }">
            <div class="col-6 pt-4">
            </div>
            <div class="col-6 pt-4">
                <p-button [styleClass]="'float-right'" [outlined]="true" (click)="activeTab = 'payment-method'; activeTabChange.emit(activeTab)">Betaalwijze beheren</p-button>
            </div>
        </div>
    </ng-template>
</p-card>